import { render, staticRenderFns } from "./ConsultingForm.vue?vue&type=template&id=1960dbf8&scoped=true"
import script from "./ConsultingForm.vue?vue&type=script&lang=js"
export * from "./ConsultingForm.vue?vue&type=script&lang=js"
import style0 from "./ConsultingForm.vue?vue&type=style&index=0&id=1960dbf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960dbf8",
  null
  
)

export default component.exports